import { MapStyles } from '@helpers/mapStyles.js';

(() => {

	//* Collect map data from DOM *//
	const gmapExists = document.querySelector('.map');
	
	if(gmapExists) {
		let geocoder, map;
		
		const gmapId = document.querySelector('.map').id;
		const gmap = document.getElementById(gmapId);
		const lat = parseFloat(gmap.dataset.latitude);
		const lng = parseFloat(gmap.dataset.longitude);
		const reg = new RegExp('\'', 'g');
		
		let markersArray = [];
		let markersNamesArray = [];
		const markerString = (gmap.dataset.markers).replace(reg, '\"');
		markersArray = JSON.parse(markerString);
		const namesString = (gmap.dataset.markersnames).replace(reg, '\"');
		markersNamesArray = JSON.parse(namesString);
		
		let markers = [];
		const zoom = parseFloat(gmap.dataset.zoom);
		const selectedStyle = (gmap.dataset.style != null) ? gmap.dataset.style : 'standard';

		//* Initialize google map */
		const initMap = () => {
			const init = new Promise(function (resolve, reject) {
				geocoder = new google.maps.Geocoder();
				const latlng = new google.maps.LatLng(lat, lng);
				const mapOptions = {
					zoom: zoom,
					center: latlng,
					styles: MapStyles[selectedStyle] //set the type of map
				};
				map = new google.maps.Map(gmap, mapOptions);
				if (map != undefined) {
					resolve('map was successfully created');
				} else {
					reject(new Error('initMap() >> initialization problem'));
				}
			});
			init
				.then(codeAddress())
				.then(setTimeout(drop(), 5000))
				.catch(err => console.log(err));
		};

		//* Helper functions *//
		const codeAddress = () => {
			const address = gmap.dataset.adr;
			geocoder.geocode({ 'address': address }, function (results, status) {
				if (status == 'OK') {
					map.setCenter(results[0].geometry.location);
					new google.maps.Marker({
						map: map,
						position: results[0].geometry.location
					});
				} else {
					console.error('Geocode was not successful for the following reason: ', status);
				}
			});
		};

		const drop = () => {
			clearMarkers();
			markersArray.forEach((marker, i) => {
				addMarkerWithTimeout(marker, i * 200, i);
			});

		};

		const addMarkerWithTimeout = (position, timeout, index) => {
			window.setTimeout(function () {
				const infowindow = new google.maps.InfoWindow({
					content: markersNamesArray[index].marker,
					maxWidth: 400
				});
				const marker_ = new google.maps.Marker({
					position: position,
					map: map,
					animation: google.maps.Animation.DROP
				});
				markers.push(marker_);
				marker_.addListener('click', function () {
					infowindow.open(map, marker_);
				});
			}, timeout);
		};

		const clearMarkers = () => {
			markers.forEach(marker => {
				marker.setMap(null);
			});
			markers = [];
		};

		// execute 'initMap' function once the page has loaded
		google.maps.event.addDomListener(window, 'load', initMap);
	}
})();


